import { useDraggable } from '@dnd-kit/core';
import React from 'react';
import styled from 'styled-components';

import { PhotoShootImageData } from 'apis/mips/types';

import { ImageTile } from './ImageTile';
import { DraggableImageData } from '../../utils/typeGuards';

type DraggableImageTileProps = {
  image: PhotoShootImageData;
  onDelete?: (imageId: string) => void;
  isDeleting?: boolean;
  isLinked?: boolean;
  isReadOnly?: boolean;
};

const Root = styled.div`
  width: 100%;
  height: 100%;
`;

export const DraggableImageTile = ({
  image,
  onDelete,
  isDeleting = false,
  isLinked = false,
  isReadOnly = false,
}: DraggableImageTileProps) => {
  const draggableData: DraggableImageData = { id: image.id, url: image.url };
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `draggablePhoto_${image.name}`,
    data: draggableData,
    disabled: isReadOnly,
  });

  return (
    <Root ref={setNodeRef} {...attributes} {...listeners}>
      <ImageTile
        image={image}
        onDelete={onDelete}
        isDeleting={isDeleting}
        isLinked={isLinked}
        isReadOnly={isReadOnly}
        isDragging={isDragging}
      />
    </Root>
  );
};
